<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title11">
<p class="p-c"><span><strong class="b">DEDICATIONS</strong></span></p>
<p class="p-c"><span><br/> <em class="i">This book is dedicated to boxing historians Dr. Nick Beck, of Los Angeles, California, the late Bob Soderman of Chicago, Illinois, and the late Bob Shepard of New York City.</em></span></p>
<p class="p-d"><span>–J.J. Johnston</span></p>
<p class="p-c"><span><br/><br/> <em class="i">To Chuck Bodak, my boxing mentor, and to my Army coach Sgt. Earl K. Hussey.</em></span></p>
<p class="p-d"><span>–Sean Curtin</span></p></a></div><a id="title11">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781439614785_ded01.vue?d0a35776